import React from "react";
import _ from "lodash";
import { dater, dt_dater } from "../../helpers";
import { DateTime } from "luxon";

// ============================ FER ==============================
export function getFerryBasicData({ reservation, t }) {
  if (!reservation) return [];

  var output = [
    [
      t("originPort"),
      <div key="originPort">
        {reservation.outbound_origin} <br />({reservation.outbound_origin_port})
      </div>,
    ],
    [
      t("destinationPort"),
      <div key="destination">
        {reservation.outbound_destination}
        <br />({reservation.outbound_destination_port})
      </div>,
    ],
    [t("reference"), reservation.reference],
    [t("outbound"), dater(reservation.outbound_departure)],
    [t("passengers"), _.sum(Object.values(reservation.pax).map((p) => p))],
    [
      t("hasReturn"),
      _.get(reservation, "service_data.legs.1.is_return_leg", false)
        ? t("yes")
        : t("no"),
    ],
  ];

  const extraOutput = [
    [
      t("created"),
      DateTime.fromISO(reservation.created).toLocaleString(
        DateTime.DATETIME_SHORT
      ),
    ],
    [
      t("status"),
      reservation.status === "CO"
        ? t("confirmed")
        : reservation.status === "CA"
        ? t("cancelled")
        : t("pending"),
    ],
  ];
  return [...output, ...extraOutput];
}

export function getFerryExtraData({ reservation, t }) {
  if (!reservation) return [];

  const output = [
    [
      t("freeCancellationAvailable"),
      reservation.non_refundable ? t("no") : t("yes"),
    ],
  ];

  const extraOutput = [
    [
      t("freeCancellationDeadline"),
      dt_dater(reservation.max_cancellation_date),
    ],
  ];
  return reservation.non_refundable ? output : [...output, ...extraOutput];
}

export function getFerryPax({ reservation, t }) {
  if (!reservation) return [];

  return _.get(reservation, "guests", []).map((guest) => [
    [t("type"), guest.guest_type_display],
    [t("title"), guest.guest_title_display],
    [t("firstName"), guest.first_name],
    [t("lastName"), guest.last_name],
    [t("email"), guest.email],
    ["leadGuest", guest.group_leader ? <strong>{t("yes")}</strong> : ""],
  ]);
}
